import { createContext } from 'react';
import { _cacheGroupTypes, useTimestamp } from './useHelpers/useTimestamp';

export const AppTimestampContext = createContext();

const AppTimestampProvider = (props) => {

  const { timestampInfo } = useTimestamp({ tsType: _cacheGroupTypes.ts })

  return <AppTimestampContext.Provider value={{ appTimestamp_state: { timestampInfo } }}>
    {props.children}
  </AppTimestampContext.Provider>
}

export default AppTimestampProvider